import { api } from '../config/api'
import { generateApiUrl } from '../utils/urlHelpers'
import { Methods, makeRequest } from './Request'

export const getUsersCompanies = (company, params) => {
  const url = generateApiUrl(api.routes.userCompanies.getList, {
    company: company.id,
  })
  return makeRequest(url, Methods.GET)
}

export const invitingUsers = (companyId, body) => {
  const url = generateApiUrl(api.routes.userCompanies.invite, {
    company: companyId,
  })
  return makeRequest(url, Methods.POST, body)
}

export const checkInvitingUsers = (companyId, body) => {
  const url = generateApiUrl(api.routes.userCompanies.checkInvite, {
    company: companyId,
  })
  return makeRequest(url, Methods.POST, body)
}
